import {FC} from 'react'
import {useHistory} from 'react-router-dom'
import {useFormContext, SubmitHandler} from 'react-hook-form'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {Label, Required} from 'jbc-front/components/presenters/form/Label'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {Input} from 'jbc-front/components/presenters/form/Input'
import {Textarea} from 'jbc-front/components/presenters/form/Textarea'
import {Note} from 'jbc-front/components/presenters/ui/Note'
import {Hint} from 'jbc-front/components/presenters/ui/Hint'
import Button from 'jbc-front/components/Button'
import Paginator from 'jbc-front/components/Paginator'
import {useSelector} from 'hooks/redux'
import {Employee, Document} from '../query'
import {Schema} from '../Presenter'
import {ContractTargetWarnings} from './ContractTargetWarnings'
import {ContractTargetList} from './ContractTargetList'
import {AgreeModal} from './AgreeModal'
import styles from './Form.scss'

// @ts-ignore
import {getMainOfficeContactInfo} from 'offices/utils'

interface FormProps {
  employee?: Employee
  documents?: {
    totalCount: number
    list: Document[]
  }
  onSubmit: SubmitHandler<Schema>
  loading: boolean
  per: number
  page: number
  setPage: (page: number) => void
  setPerPage: (per: number) => void
}

export const Form: FC<FormProps> = ({employee, documents, onSubmit, loading, per, page, setPage, setPerPage}) => {
  const history = useHistory()
  const currentOffice = useSelector((state) => state.client.current.office)
  const currentUser = useSelector((state) => state.session.currentUser)
  const senderClientName = getMainOfficeContactInfo(currentOffice).name
  const {
    register,
    formState: {errors},
  } = useFormContext<Schema>()

  return (
    <>
      <div className="u-mb20">
        <p>以下の内容で電子契約署名依頼メールを送信します。</p>
        <p className={styles.annotation}>※電子契約はメールアドレスが設定されている従業員に対してのみ送信されます</p>
      </div>
      <div className={styles.contractInfoBox}>
        <div className="u-mb20">
          <div className={styles.label}>差出人</div>
          <p className={styles.text}>
            {senderClientName} {currentUser.name || currentUser.employee?.display_full_name}
          </p>
        </div>

        <Label>
          書類名
          <Hint leftPoint={-10}>署名依頼メールの件名、本文に表示されます</Hint>
          <Spacer direction="x" size={5} />
          <Required />
        </Label>
        <Spacer size={8} />
        <Input {...register('title')} isError={!!errors.title?.message} />
        {errors.title?.message && <ErrorMessage>{errors.title.message}</ErrorMessage>}

        <Spacer size={20} />

        <Label>
          コメント
          <Hint leftPoint={-10}>署名依頼メール本文に送信先へのコメントを記載できます</Hint>
        </Label>
        <Spacer size={8} />
        <Textarea {...register('comment')} isError={!!errors.comment?.message} />
        <Note>最大2000文字</Note>
        {errors.comment?.message && <ErrorMessage>{errors.comment.message}</ErrorMessage>}

        <Spacer size={20} />
      </div>

      {employee && <ContractTargetWarnings employee={employee} />}

      <ContractTargetList documents={documents} loading={loading} per={per} page={page} setPerPage={setPerPage} />

      <Paginator
        current={page}
        rowsPerPage={per}
        onClick={(page) => setPage(page)}
        totalResult={documents?.totalCount}
      />

      <div className="u-ta-c">
        <span className={styles.button}>
          <Button onClick={() => history.push(`/documents/employees/${employee?.id}`)}>キャンセル</Button>
        </span>
        <span className={styles.button}>
          <AgreeModal onSubmit={onSubmit} loading={loading} />
        </span>
      </div>
    </>
  )
}
